(function () {
  function isMobileFooterVisible(root) {
    var mobile = root.querySelector('.c27-footer__mobile');
    return mobile && window.getComputedStyle(mobile).display !== 'none';
  }

  function fitMobileConsentFont(root) {
    if (!isMobileFooterVisible(root)) return;

    var block = root.querySelector('.c27-footer__mobile-newsletter');
    if (!block) return;

    var heading = block.querySelector('.c27-footer__newsletter-heading');
    var label = block.querySelector('.c27-footer__consent');
    var line1 = block.querySelector('.c27-footer__consent-line1');
    if (!label || !line1) return;

    var emailWrap = block.querySelector('.c27-footer__email-wrap');
    var targetW = emailWrap
      ? emailWrap.getBoundingClientRect().width
      : block.getBoundingClientRect().width;
    if (targetW < 1) return;

    var checkbox = label.querySelector('input[type="checkbox"]');
    var checkW = checkbox ? checkbox.getBoundingClientRect().width : 0;
    var checkMarginRight = checkbox ? parseFloat(window.getComputedStyle(checkbox).marginRight) || 0 : 0;
    var textTargetW = Math.max(0, targetW - checkW - checkMarginRight);

    label.style.width = '100%';
    label.style.maxWidth = 'none';
    label.style.marginLeft = '0';
    label.style.marginRight = '0';
    label.style.fontSize = '';

    var min = 8;
    var max = 14;
    var best = 11;
    for (var size = min; size <= max; size += 0.25) {
      label.style.fontSize = size + 'px';
      if (line1.getBoundingClientRect().width <= textTargetW + 1) best = size;
      else break;
    }
    label.style.fontSize = best + 'px';
  }

  function scheduleConsentFit(root) {
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        fitMobileConsentFont(root);
      });
    });
  }

  function initFooter(root) {
    if (!root || root.dataset.c27FooterInit === 'true') return;
    root.dataset.c27FooterInit = 'true';

    root.querySelectorAll('[data-c27-footer-accordion-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('[data-c27-footer-accordion-item]');
        if (!item) return;

        var isOpen = item.classList.contains('is-open');
        root.querySelectorAll('[data-c27-footer-accordion-item]').forEach(function (other) {
          other.classList.remove('is-open');
          var otherTrigger = other.querySelector('[data-c27-footer-accordion-trigger]');
          if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });

    root.querySelectorAll('[data-c27-footer-locale-toggle]').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var panel = toggle.parentElement.querySelector('[data-c27-footer-locale-panel]');
        if (!panel) return;
        var isHidden = panel.hasAttribute('hidden');
        root.querySelectorAll('[data-c27-footer-locale-panel]').forEach(function (other) {
          other.setAttribute('hidden', '');
        });
        if (isHidden) panel.removeAttribute('hidden');
      });
    });

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-c27-footer-locale]')) return;
      root.querySelectorAll('[data-c27-footer-locale-panel]').forEach(function (panel) {
        panel.setAttribute('hidden', '');
      });
    });

    scheduleConsentFit(root);
    window.addEventListener('resize', function () {
      scheduleConsentFit(root);
    }, { passive: true });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        scheduleConsentFit(root);
      });
    }
    if (typeof ResizeObserver !== 'undefined') {
      var newsletterBlock = root.querySelector('.c27-footer__mobile-newsletter');
      if (newsletterBlock) {
        var consentFitRo = new ResizeObserver(function () {
          scheduleConsentFit(root);
        });
        consentFitRo.observe(newsletterBlock);
      }
    }
  }

  function initAllFooters() {
    document.querySelectorAll('[data-c27-footer]').forEach(function (root) {
      initFooter(root);
      scheduleConsentFit(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllFooters);
  } else {
    initAllFooters();
  }
  window.addEventListener('load', initAllFooters);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-c27-footer]');
    if (!root) return;
    root.dataset.c27FooterInit = '';
    initFooter(root);
    scheduleConsentFit(root);
  });
})();
